import React, { useState, useEffect } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import Select from "react-select";
import axios from "axios";
import Sidebar from "../../Dashboard/Sidebar/Sidebar";
import config from "../../../config/config";
import Loader from "../../../components/Loader/Loader";
import Moment from "moment";
import {
  ALREADY_EXIST,
  ERROR_MESSAGE,
  SUCCESS_MESSAGE,
  CUSTOM_SELECT_DROPDOWN_STYLE,
} from "../../../common/Constant";
import { toastError, toastSuccess } from "../../../common/Toast";
import { RFC_2822 } from "moment";
// import DeleteConfirmationModal from "../../../../components/Modal/DeleteConfirmation";
// import { checkUserPermission } from "../../../../common/UserPermission";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown, faChevronUp } from "@fortawesome/free-solid-svg-icons";
import { TreeSelect } from "primereact/treeselect";
import "primereact/resources/themes/lara-light-indigo/theme.css"; // theme
import "primereact/resources/primereact.css"; // core css
import "primeicons/primeicons.css"; // icons
import "primeflex/primeflex.css";

const AccountTypeManage = (props) => {
  const paramObject = useParams();
  let navigate = useNavigate();
  const token = localStorage.getItem("Token");
  const loginUserId = localStorage.getItem("ID");
  const [loading, setLoading] = useState(false);
  const [acoounttypedata, setAcoounttypedata] = useState([]);
  const [SelectedChartofAccount, setSelectedChartofAccount] = useState(0);
  const [SelectedAccountType, setSelectedAccountType] = useState(0);
  const [selectedType, setSelectedType] = useState(0);

  const [selectedAccountTypeID, setSelectedAccountTypeID] = useState(0);
  const [SelectedAccountDetails, setSelectedAccountDetails] = useState(0);
  const [Accounttype, setAccounttype] = useState([]);
  const [AccountDetailstype, setAccountDetailstype] = useState([]);
  const [hideAccounttype, sethideAccounttype] = useState(0);
  const [hideDetails, sethideDetails] = useState(0);
  const [hideTaxformsection, sethideTaxformsection] = useState(0);
  const [childaccountquickbookid, setchildaccountquickbookid] = useState(0);
   const[selectedAccountName,setselectedAccountName]=useState("")
  const [formValues, setFormValues] = useState({
    Name: "",
    Description: "",
    Amount: 0,
  });
  const [activeButton, setActiveButton] = useState(paramObject.id > 0 ? 0 : 1);
  const [previewdata, setPreviewData] = useState(false);
  const [value, setValue] = useState(0);
  const [listdata, setListData] = useState(false);
  const [income, setIncome] = useState(false);
  const [account, setAccount] = useState("");
  const [date, setDate] = useState(false);
  const [datevalue, setDateValue] = useState();
  const [incoming, setIncoming] = useState(0);
  const [previewdata1, setPreviewData1] = useState(false);
  const [originalPreviewDisplay, setOriginalPreviewDisplay] = useState([]);
  const [previewdisplay, setPreviewDisplay] = useState([]);
  const [accountName, setAccountName] = useState("");
  const [accounttypelist, setAccountTypeList] = useState([]);
  const [tree, setTree] = useState([]);
  const [selectedaccounttypedata, setSelectedAccountTypeData] = useState({});
  const [responsedata, setResponseData] = useState([]);
  // const [previewname, setPreviewName]=useState("")
  const [parentvalue, setParentValue] = useState(0);
  const [quickbookid, setQuickbookId] = useState(0);

  const validationSchema = Yup.object().shape({
    Name: Yup.string().required("Name is required"),
  });

  let _selectedAccountType = 0;

  console.log(tree, "tree optiomns");

  const handleChangeforChartofaccount = (val) => {
    // console.log(1)
    console.log(val, "bbb");
    setSelectedChartofAccount();
    setActiveButton(val);
    sethideAccounttype(val);
    setSelectedAccountType("");
    setSelectedAccountDetails("");
    sethideTaxformsection(0);
    sethideDetails(0);
    let clean = {
      ID: 0,
      Name: "",
      Description: "",
      Amount: 0,
    };
    setFormValues(clean);
    BindChartofaccount(val);
  };

  // console.log(activeButton,"activeButton")

  const BindChartofaccount = (val) => {
    // console.log(val,"selectedaccounttypedata")
    axios
      .get(
        `${config.accountingBaseUrl}/chartofaccounts/accounttypefordropdown?id=${val}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        const responsedata = res.data.ResponseData.AccountTypeList.map(
          (item, index) => {
            return {
              key: "TYPE_" + item.ID,
              label: item.Name,
              AccountTypeID: item.AccountTypeID,
              accountTypename:item.accountTypename,
              Type: item.Type,
              QuickbookId: item.QuickbookId,
              ParentID: 0,
            };
          }
        );
        setAccountTypeList(responsedata);
        const accountlist = res.data.ResponseData.AccountList;

        const formattedOptions = transformOptions(accountlist, 0);
        // console.log(formattedOptions, "formatted")
        setAccounttype(formattedOptions);

        // setOriginalPreviewDisplay(res.data.ResponseData.AccountList);

        const accountTypeList_New = res.data.ResponseData.AccountTypeList.map(
          (item, index) => {
            return {
              key: "TYPE_" + item.ID,
              label: item.Name,
              AccountTypeID: item.AccountTypeID,
              Type: item.Type,
              ParentID: 0,
              ParentAccountKey: "",
            };
          }
        );

        const accountList_New = res.data.ResponseData.AccountList.map(
          (item, index) => {
            return {
              key: item.ID,
              label: item.Name,
              AccountTypeID: item.AccountTypeID,
              Type: item.Type,
              ParentID: item.ParentID,
              ParentAccountKey: "TYPE_" + item.AccountTypeID,
            };
          }
        );

        setOriginalPreviewDisplay([...accountTypeList_New, ...accountList_New]);

        console.log("originalPreviewDisplay ::==>", originalPreviewDisplay);
        // setPreviewDisplay(formattedOptions);

        // console.log("res?.data?.ResponseData 84", res?.data?.ResponseData)
        console.log("::__", res);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  console.log(SelectedAccountType, "SelectedAccountType");

  useEffect(() => {
    // console.log(Accounttype,"Accounttype")
    const buildtree = buildAccountsTree(Accounttype, accounttypelist);
    console.log(buildtree, "buildtree");
    setTree(buildtree);
    // setOriginalPreviewDisplay(buildtree);
    setPreviewDisplay(buildtree);
  }, [Accounttype]);

  function buildAccountsTree(accountList, accountTypeList) {
    console.log(accountList, "accountList");
    console.log(accountTypeList, "accountTypeList");
    const accountTypeMap = new Map();
    const rootAccountTypes = [];

    // Create a map of ID to its corresponding account type object
    for (const accountType of accountTypeList) {
      // accountTypeMap.set(accountType.key, { ...accountType, children: [] });
      accountTypeMap.set(accountType.AccountTypeID, {
        ...accountType,
        children: [],
      });
    }

    // Traverse the accountList to build the tree structure
    for (const account of accountList) {
      const { ID, AccountTypeID } = account;
      const accountType = accountTypeMap.get(AccountTypeID);

      if (accountType) {
        accountType.children.push(account);
      }
      //   console.log(accountType,"accountType")
    }

    // Get the root account types (whose AccountTypeID matches no ID in accountTypeList)
    // console.log(accountTypeMap.values(),"ssss")
    // for (const accountType of accountTypeMap.values()) {
    //   if (accountType.children.length === 0) {
    //     rootAccountTypes.push(accountType);
    //   }
    // }
    console.log(accountTypeMap, "accountTypeMap");
    const outputArray = Array.from(accountTypeMap.values());
    const data = outputArray.sort((a, b) => a.label.localeCompare(b.label));
    console.log(data, "data");
    return data;
  }

  const handleChangeforaccountType = (e) => {
    console.log(e, "event");
    setParentValue(e.value);
    const founddata = findObjectByKey(tree, e.value);
    console.log(founddata, "founddata");

    BindAccountTypeDetails(founddata.AccountTypeID);
    sethideAccounttype(founddata.AccountTypeID);
    setchildaccountquickbookid(founddata.QuickbookId);
    sethideTaxformsection(founddata.AccountTypeID);
    setSelectedAccountType(founddata.key);
    setSelectedType(founddata.Type);
    setSelectedAccountTypeID(founddata.AccountTypeID);
    setselectedAccountName(founddata.accountTypename);
    _selectedAccountType = founddata.AccountTypeID;
    let existingItemIndex;
    if (paramObject.id > 0) {
      existingItemIndex = originalPreviewDisplay.length;
    }
    BindingPreview(
      accountName,
      founddata.AccountTypeID,
      founddata.Type,
      founddata.key,
      existingItemIndex
    );

    function findObjectByKey(data, keyToFind) {
      for (const item of data) {
        if (item.key === keyToFind) {
          return item;
        }

        if (item.children && item.children.length > 0) {
          const foundInChildren = findObjectByKey(item.children, keyToFind);
          if (foundInChildren) {
            return foundInChildren;
          }
        }
      }

      return null;
    }

    // console.log(e, "valhuhh")
    // console.log(accountName, "accountname")
  };

  console.log(hideAccounttype, "hideAccounttype");

  const BindAccountTypeDetails = (val) => {
    console.log(val, "val");
    axios
      .get(
        `${config.accountingBaseUrl}/chartofaccounts/accountdetailstypeddl?id=${val}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        setAccountDetailstype(res.data.ResponseData);
        console.log(res.data.ResponseData, "response12345");
       // setSelectedAccountDetails(res.data.ResponseData)

        
        
      })
      .catch((err) => {
        console.log(err);
      });
  };

  console.log(AccountDetailstype, "AccountDetailstype");

  const handlelistdata = () => {
    setListData(!listdata);
  };

  const options = [
    { value: 1, label: "Beginning of this year" },
    { value: 2, label: "Beginning of this month" },
    { value: 3, label: "Today" },
    { value: 4, label: "Other date" },
  ];

  const handleChangeforTaxForm = (e) => {
    console.log(e , "dataneed");
    
    setSelectedAccountDetails(e);
    sethideTaxformsection(e.value);
    sethideDetails(e.value);
  };

  const handledateChange = (e) => {
    setDateValue(e.target.value);
    setDate(true);
  };

  const handledropdwon = (values) => {
    // console.log("values", values);
    axios
      .get(`${config.accountingBaseUrl}/chartofaccounts/accouttypeddl`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        console.log("::>>>", res);
        setAcoounttypedata(res.data.ResponseData);
      });
  };

  console.log(
    tree.find((e) => e.key === SelectedAccountType)?.label,
    "accounttype++++>"
  );

  const handledata = (e) => {
    setValue(e.value);
  };

  let ChartOfAccountTypeList = [];
  const ChartofAccTypes = acoounttypedata.map((u, i) => {
    ChartOfAccountTypeList[i] = { label: u.Name, value: u.Id };
  });

  let AccountTypeList = [];
  const AccTypes = Accounttype?.map((u, i) => {
    AccountTypeList[i] = {
      label: u.Name,
      value: u.ID,
      QuickbookId: u.QuickbookId,
    };
  });

  // console.log(AccountTypeList, "account")

  let AccountDetailsTypeList = [];
  const AccDetailsTypes = AccountDetailstype?.map((u, i) => {
    AccountDetailsTypeList[i] = { label: u.Name, value: u.ID ,QuickBookCode:u.QuickBookCode };
  });
  console.log(AccountDetailsTypeList, "AccountDetailsTypeList");

  const handleSubmit = (values) => {
    // console.log(":ss", {
    //     id: paramObject.id || 0,
    //     name: values.Name,
    //     description: values.Description,
    //     chartofaccounttypeid: SelectedChartofAccount.value,
    //     accounttypeid: SelectedAccountType.value,
    //     accountdetailtypeid: SelectedAccountDetails.value,
    //     loginuserid: loginUserId,
    //     isactive: 1,
    // });
    // console.log("selectAcounttype", values.Name, values.Description, hideAccounttype, hideDetails, hideTaxformsection);
    setLoading(true);
    axios
      .post(
        `${config.accountingBaseUrl}/chartofaccounts/accountupsert`,
        {
          id: paramObject.id || 0,
          name: values.Name,
          description: values.Description,
          chartofaccounttypeid: activeButton,
          accounttypeid: selectedAccountTypeID,
          accountdetailtypeid: SelectedAccountDetails.value,
          accountdetailtypelabel: SelectedAccountDetails.QuickBookCode,
          loginuserid: loginUserId,
          isactive: 1,
          amount: values.Amount,
          parentid: parentvalue,
          openingdate:
            (value == 1 && lastyear) ||
            (value == 2 &&
              Moment(lastDayPrevMonthForLastMonth).format("YYYY-MM-DD")) ||
            (value == 3 && Moment(currentdate).format("YYYY-MM-DD")) ||
            (value == 4 && datevalue),
          quickbookid: quickbookid,
          accounttype: selectedAccountName||tree.find((e) => e.key === SelectedAccountType)?.label,
          childquickbookid: childaccountquickbookid || 0,
          // activeButton == 3
          //   ? "Bank"
          //   : "" || activeButton == 2
          //   ? "Expense"
          //   : "" || activeButton == 1
          //   ? "Income"
          //   : "" || activeButton == 4
          //   ? "Asset"
          //   : "" || activeButton == 5
          //   ? "Credit Card"
          //   : "" || activeButton == 6
          //   ? "Liabilitie"
          //   : "" || activeButton == 7
          //   ? "Equity"
          //   : "",
        },
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        if (res.data.ResponseCode === "SUCCESS" && res.data.ResponseID > 0) {
          toastSuccess(SUCCESS_MESSAGE);
          navigate(`/accounting`);
          if (values.buttonType === "saveAndClose") {
            navigate("/accounting");
          } else {
            window.location.reload(true);
          }
        } else if (
          res.data.ResponseCode === "ERROR" &&
          res.data.ResponseID === -1
        ) {
          toastError("Name" + ALREADY_EXIST);
        } else {
          toastError(ERROR_MESSAGE);
        }
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
      });
  };

  console.log(paramObject.id, "paramobject");

  useEffect(() => {
    handledropdwon();

    if (paramObject.id > 0) {
      setLoading(true);
      axios
        .get(
          `${config.accountingBaseUrl}/chartofaccounts/accountselectbyid?id=${paramObject.id}`,
          {
            headers: {
              "Content-Type": "application/json;charset=UTF-8",
              Authorization: token,
            },
          }
        )
        .then((res) => {
          console.log("res.data.ResponseData[0]", res.data.ResponseData);
          const AccountTypeData = res.data.ResponseData[0];
          setQuickbookId(AccountTypeData.QuickbookId);
          setSelectedAccountTypeData(AccountTypeData);
          setActiveButton(AccountTypeData.ChartOfAccountTypeID);
          // console.log(res.data.ResponseData[0].AccountTypeID,"accounttypeid")
          setSelectedAccountType(
            AccountTypeData.ParentID == 0
              ? `TYPE_${AccountTypeData.AccountTypeID}`
              : AccountTypeData.ParentID
          );
          setSelectedAccountTypeID(AccountTypeData.AccountTypeID);
          setAccountName(res.data.ResponseData[0].AccountName);
          // setPreviewName(res.data.ResponseData[0].AccountName)
          // setChartOfAccountID(res.data.ResponseData[0].ChartOfAccountTypeID)
          setIncoming(res.data.ResponseData[0].ChartOfAccountTypeID);
          // setSelectedChartofAccount(AccountTypeData.ChartOfAccountTypeID)
          let getdata = {
            Name: AccountTypeData.AccountName,
            Description: AccountTypeData.Description,
            Amount: AccountTypeData.Amount,
          };
          setFormValues(getdata);

          axios
            .get(`${config.accountingBaseUrl}/chartofaccounts/accouttypeddl`, {
              headers: {
                "Content-Type": "application/json;charset=UTF-8",
                Authorization: token,
              },
            })
            .then((res) => {
              console.log("::>>>", res);
              setAcoounttypedata(res.data.ResponseData);
            });

          axios
            .get(
              `${config.accountingBaseUrl}/chartofaccounts/accountdetailstypeddl?id=${AccountTypeData.AccountTypeID}`,
              {
                headers: {
                  "Content-Type": "application/json;charset=UTF-8",
                  Authorization: token,
                },
              }
            )
            .then((res) => {

              setAccountDetailstype(res.data.ResponseData);
              console.log(res,"res.data.ResponseData");
             
              res.data.ResponseData.map((selectedAccounttype) => {
                if (
                  selectedAccounttype.ID === AccountTypeData.AccountDetailTypeID
                ) {
                  setSelectedAccountDetails({
                    label: selectedAccounttype.Name,
                    value: selectedAccounttype.ID,
                    QuickBookCode:selectedAccounttype.QuickBookCode,
                  });
                  sethideTaxformsection(1);
                  sethideDetails(1);
                }
              });
              console.log(res);
            })
            .catch((err) => {
              console.log(err);
            });

          setLoading(false);
        })
        .catch((err) => {
          setLoading(false);
        });
    }
  }, []);

  console.log(activeButton, "activeButton");

  // console.log(selectedaccounttypedata,"selectedaccounttypedata")
  useEffect(() => {
    // console.log(selectedaccounttypedata?.ChartOfAccountTypeID,"selectedaccounttypedata")
    // if(paramObject.id > 0){
    axios
      .get(
        `${config.accountingBaseUrl}/chartofaccounts/accounttypefordropdown?id=${activeButton}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        const responsedata = res.data.ResponseData.AccountTypeList.map(
          (item, index) => {
            return {
              key: "TYPE_" + item.ID,
              label: item.Name,
              AccountTypeID: item.AccountTypeID,
              Type: item.Type,
              accountTypename:item.accountTypename,
              QuickbookId: item.QuickbookId,
              ParentID: 0,
            };
          }
        );
        setAccountTypeList(responsedata);
        const accountlist = res.data.ResponseData.AccountList;

        const formattedOptions = transformOptions(accountlist, 0);
        // console.log(formattedOptions, "formatted")
        setAccounttype(formattedOptions);

        // setOriginalPreviewDisplay(res.data.ResponseData.AccountList);

        const accountTypeList_New = res.data.ResponseData.AccountTypeList.map(
          (item, index) => {
            return {
              key: "TYPE_" + item.ID,
              label: item.Name,
              AccountTypeID: item.AccountTypeID,
              Type: item.Type,
              ParentID: 0,
              ParentAccountKey: "",
            };
          }
        );

        const accountList_New = res.data.ResponseData.AccountList.map(
          (item, index) => {
            return {
              key: item.ID,
              label: item.Name,
              AccountTypeID: item.AccountTypeID,
              Type: item.Type,
              ParentID: item.ParentID,
              ParentAccountKey: "TYPE_" + item.AccountTypeID,
            };
          }
        );

        setOriginalPreviewDisplay([...accountTypeList_New, ...accountList_New]);

        console.log("originalPreviewDisplay ::==>", originalPreviewDisplay);
        // setPreviewDisplay(formattedOptions);

        // console.log("res?.data?.ResponseData 84", res?.data?.ResponseData)
        console.log("::__", res);
      })
      .catch((err) => {
        console.log(err);
      });

    // }
  }, [activeButton]);

  function transformOptions(data, parentId = 0) {
    // console.log(1)
    console.log(data, "data2222");
    const result = [];

    data = data.sort((a, b) => a.Name.localeCompare(b.Name));

    console.log(data, "data filterd");
    for (const item of data) {
      // console.log(item, "item")
      // console.log(parentId, "id")
      if (item.ParentID === parentId) {
        // Create a new object to represent the current item
        console.log(1);
        const currentItem = {
          key: item.ID,
          label: item.Name,
          ParentID: item.ParentID,
          AccountTypeID: item.AccountTypeID,
          QuickbookId: item.QuickbookId,
          accountTypename:item.accountTypename,
          Type: item.Type,
          children: transformOptions(data, item.ID),
        };

        // console.log(currentItem, "currentitem")

        if (currentItem.children.length == 0) {
          result.push({
            key: item.ID,
            label: item.Name,
            ParentID: item.ParentID,
            AccountTypeID: item.AccountTypeID,
            Type: item.Type,
            QuickbookId: item.QuickbookId,
            accountTypename:item.accountTypename,
          });
        } else {
          result.push(currentItem);
        }
      }
    }

    console.log(result, "result");

    return result;
  }

  const todayForLastMonth = new Date();
  const firstDayCurrentMonthForLastMonth = new Date(
    todayForLastMonth.getFullYear(),
    todayForLastMonth.getMonth(),
    1
  );
  const lastDayPrevMonthForLastMonth = new Date(
    firstDayCurrentMonthForLastMonth.getTime() - 1
  );

  //   console.log(lastDayPrevMonthForLastMonth, "ldfm")

  const customStyles = {
    control: (provided) => ({
      ...provided,
      marginBottom: "10px",
    }),
    option: (provided, { data, isDisabled, isFocused, isSelected }) => ({
      ...provided,
      paddingLeft: data.options ? "8px" : "24px", // Indent child options
      backgroundColor: isSelected ? "#F5F5F5" : "transparent",
      color: isSelected ? "#333" : "#666",
      cursor: isDisabled ? "not-allowed" : "pointer",
    }),
  };

  let currentdate = new Date();
  const currentYear = currentdate.getFullYear();
  const lastDayOfCurrentYear = new Date(currentYear, 11, 31);
  const previousYear = currentYear - 1;
  const lastDayOfPreviousYear = new Date(previousYear, 11, 31);
  const lastyear = lastDayOfPreviousYear.toISOString().slice(0, 10);
  console.log(SelectedAccountType, "selected1");

  const handleInputChange = (e) => {
    // console.log(e.target.value,"event")
    // console.log(selectedAccountTypeID,"selectedaccounttypeid")
    let existingItemIndex;
    if (paramObject.id > 0) {
      existingItemIndex = originalPreviewDisplay.findIndex(
        (item) => item.label == accountName
      );
    }
    setAccountName(e.target.value);

    BindingPreview(
      e.target.value,
      selectedAccountTypeID,
      selectedType,
      SelectedAccountType,
      existingItemIndex
    );
  };

  const BindingPreview = (
    accountName,
    selectedAccountTypeID,
    type,
    key,
    existingItemIndex
  ) => {
    // console.log(selectedAccountTypeID,"selectedAccountTypeID")

    // console.log(accountName,"accountName")
    // console.log(selectedAccountTypeID,"selectedAccountTypeID")

    console.log(_selectedAccountType, "selectedaccount1");
    console.log(originalPreviewDisplay, "originalPreviewDisplay");

    if (paramObject.id > 0) {
      const existingItem = originalPreviewDisplay[existingItemIndex];

      if (existingItem == undefined) {
        let obj = {
          key: -2,
          label: accountName,
          ParentID: type == "ACCOUNT" ? key : 0,
          AccountTypeID: selectedAccountTypeID,
          Type: "ACCOUNT",
          ParentTypeKey: "TYPE_" + selectedAccountTypeID,
        };
        setOriginalPreviewDisplay([...originalPreviewDisplay, obj]);
      } else {
        existingItem.label = accountName;
        existingItem.key = existingItem.key;
        existingItem.AccountTypeID = existingItem.AccountTypeID;
        existingItem.ParentID = existingItem.ParentID;
        existingItem.ParentAccountKey = existingItem.ParentAccountKey;

        const updatedDataNew = [...originalPreviewDisplay];
        updatedDataNew[existingItemIndex] = existingItem;
        setOriginalPreviewDisplay(updatedDataNew);
      }
    } else {
      const existingItemIndex = originalPreviewDisplay.findIndex(
        (item) => item.key == -2
      );
      if (existingItemIndex != -1) {
        const existingItem = originalPreviewDisplay[existingItemIndex];
        // existingItem.label = accountName;
        // existingItem.ParentID = selectedAccountTypeID > 0 ? selectedAccountTypeID : SelectedAccountType;

        // existingItem.Name = accountName;
        // existingItem.ParentID = type == "ACCOUNT" ? key : 0 ;
        // existingItem.AccountTypeID = selectedAccountTypeID;

        existingItem.label = accountName;
        existingItem.ParentID = type == "ACCOUNT" ? key : 0;
        existingItem.AccountTypeID = selectedAccountTypeID;
        existingItem.ParentTypeKey = "TYPE_" + selectedAccountTypeID;

        const updatedDataNew = [...originalPreviewDisplay];
        updatedDataNew[existingItemIndex] = existingItem;
        setOriginalPreviewDisplay(updatedDataNew);
      } else {
        let obj = {
          key: -2,
          label: accountName,
          ParentID: type == "ACCOUNT" ? key : 0,
          AccountTypeID: selectedAccountTypeID,
          Type: "ACCOUNT",
          ParentTypeKey: "TYPE_" + selectedAccountTypeID,
        };
        console.log(obj, "obj==>");
        // console.log(originalPreviewDisplay,"originalpreviewdisplay");
        setOriginalPreviewDisplay([...originalPreviewDisplay, obj]);
        // displaydata()
      }
    }
    setResponseData(originalPreviewDisplay);
    const responseData = originalPreviewDisplay;
    console.log(responseData, "responsedata");

    const formattedOptions = createHierarchy(responseData, 0);
    // const formattedOptions = transformPreviewOptions(responseData,"")
    const filtereddata = formattedOptions.filter(
      (item, index) => item.Type == "ACCOUNTTYPE"
    );
    console.log(filtereddata, "filtereddata");

    setPreviewDisplay(filtereddata);
  };

  console.log(previewdisplay, "previewdisplay");

  // function transformPreviewOptions_New(data, parentId = "") {
  //     console.log("data==>", data);
  //     const result = [];

  //     for (const item of data) {
  //       if (item.ParentAccountKey === parentId) {

  //         const children = transformPreviewOptions_New(data, item.key);

  //         const existingChildren = item.children || [];
  //         const mergedChildren = [...existingChildren, ...children];

  //         mergedChildren.sort((a, b) => a.label.localeCompare(b.label));

  //         const currentItem = {
  //           key: item.key,
  //           label: item.label,
  //           AccountTypeID: item.AccountTypeID,
  //           Type: item.Type,
  //           ParentAccountKey: item.ParentAccountKey,
  //           children: mergedChildren
  //         };

  //         result.push(currentItem);
  //       }
  //     }
  //     console.log(result,"result")
  //     return result;
  //   }

  // function transformPreviewOptions(data, parentId = 0) {
  //     console.log("data==>", data);
  //     const result = [];

  //     for (const item of data) {
  //       if (item.ParentID === parentId) {
  //         const children = transformPreviewOptions(data, item.ID);

  //         const existingChildren = item.children || [];
  //         const mergedChildren = [...existingChildren, ...children];

  //         mergedChildren.sort((a, b) => a.Name.localeCompare(b.Name));

  //         const currentItem = {
  //           key: item.ID,
  //           label: item.Name,
  //           AccountTypeID: item.AccountTypeID,
  //           Type: item.Type,
  //           children: mergedChildren
  //         };

  //         result.push(currentItem);
  //       }
  //     }

  //     return result;
  //   }

  function createHierarchy(dataList, parentID = 0) {
    const result = [];
    // dataList = dataList.sort((a, b) => a.label.localeCompare(b.label))
    dataList.forEach((item) => {
      if (item.ParentID === parentID) {
        const newItem = { ...item, children: [] };

        const children = createHierarchy(dataList, item.key);
        if (children.length > 0) {
          newItem.children = children;
        }

        result.push(newItem);
      }
    });
    console.log(result, "result");
    createHierarch(result);
    return result;
  }

  function createHierarch(dataList) {
    // console.log(dataList,"dataList")
    const hierarchy = {};

    // dataList = dataList.sort((a, b) => a.label.localeCompare(b.label))

    dataList.forEach((item) => {
      if (item.Type === "ACCOUNTTYPE") {
        item.children = [];
        hierarchy[item.key] = item;
      } else {
        const parent = Object.values(hierarchy).find(
          (parentItem) => parentItem.AccountTypeID === item.AccountTypeID
        );
        if (parent) {
          parent.children.push(item);
        }
      }
    });
    const val = Object.values(hierarchy).filter((item) => item.ParentID === 0);
    console.log(val, "val456");

    return Object.values(hierarchy).filter((item) => item.ParentID === 0);
  }

  useEffect(() => {
    const formattedOptions = createHierarchy(originalPreviewDisplay, 0);
    // const formattedOptions = transformPreviewOptions(responseData,"")

    const filtereddata = formattedOptions.filter(
      (item, index) => item.Type == "ACCOUNTTYPE"
    );
    console.log(filtereddata, "filtereddata");

    setPreviewDisplay(filtereddata);
  }, [responsedata]);

  console.log(SelectedAccountType, "SelectedAccountType");
  // console.log(tree,"tree")

  return (
    <>
      <Sidebar />
      <Loader loading={loading} />
      <div className="page-wrapper cardhead">
        <div className="content container-fluid">
          {/* Page Header */}
          <div
            className="page-header"
            style={{
              position: "fixed",
              top: "2px",
              zIndex: "999",
            }}
          >
            <div className="row breadcrumb-position">
              {/* <div className="col"> */}
              {/* <h6 className="page-title">Accounting</h6> */}
              <ul className="breadcrumb">
                <li className="breadcrumb-item" style={{ marginLeft: "12px" }}>
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/accounting">Accounting</Link>
                </li>
                <li className="breadcrumb-item active">Manage Accounts</li>
              </ul>
              {/* </div> */}
            </div>
          </div>
          <div className="card">
            <div className="card-header">
              <h5 className="card-title">Manage Account</h5>
            </div>

            <div className="d-flex pt-10 pl-10">
              <div style={{ marginLeft: "10px" }}>
                <button
                  className={
                    activeButton == 1
                      ? "btn btn-sm btn-secondary mt-1"
                      : "btn btn-sm btn-secondary mt-1"
                  }
                  onClick={() => {
                    handleChangeforChartofaccount(1);
                    setPreviewData(false);
                    setIncome(true);
                  }}
                >
                  <i className="fa fa-suitcase"></i> Income
                </button>
              </div>
              <div style={{ marginLeft: "10px" }}>
                <button
                  className={
                    activeButton == 2
                      ? "btn btn-sm btn-secondary mt-1"
                      : "btn btn-sm btn-secondary mt-1"
                  }
                  onClick={() => {
                    handleChangeforChartofaccount(2);
                    setPreviewData(false);
                    setIncome(true);
                  }}
                >
                  <i className="fa fa-eraser"></i> Expenses
                </button>
              </div>
              <div style={{ marginLeft: "10px" }}>
                <button
                  className={
                    activeButton == 3
                      ? "btn btn-sm btn-secondary mt-1"
                      : "btn btn-sm btn-secondary mt-1"
                  }
                  onClick={() => {
                    handleChangeforChartofaccount(3);
                    setPreviewData(true);
                    setIncome(false);
                  }}
                >
                  <i className="fa fa-bank"></i> Banks
                </button>
              </div>
              <div style={{ marginLeft: "10px" }}>
                <button
                  className={
                    activeButton == 4
                      ? "btn btn-sm btn-secondary mt-1"
                      : "btn btn-sm btn-secondary mt-1"
                  }
                  onClick={() => {
                    handleChangeforChartofaccount(4);
                    setPreviewData(true);
                    setIncome(false);
                  }}
                >
                  <i className="fa fa-truck"></i> Assets
                </button>
              </div>
              <div style={{ marginLeft: "10px" }}>
                <button
                  className={
                    activeButton == 5
                      ? "btn btn-sm btn-secondary mt-1"
                      : "btn btn-sm btn-secondary mt-1"
                  }
                  onClick={() => {
                    handleChangeforChartofaccount(5);
                    setPreviewData(true);
                    setIncome(false);
                  }}
                >
                  {" "}
                  <i className="fa fa-credit-card"></i> Credit Cards
                </button>
              </div>
              <div style={{ marginLeft: "10px" }}>
                <button
                  className={
                    activeButton == 6
                      ? "btn btn-sm btn-secondary mt-1"
                      : "btn btn-sm btn-secondary mt-1"
                  }
                  onClick={() => {
                    handleChangeforChartofaccount(6);
                    setPreviewData(true);
                    setIncome(false);
                  }}
                >
                  <i className="fa fa-home"></i> Liabilities
                </button>
              </div>
              <div style={{ marginLeft: "10px" }}>
                <button
                  className={
                    activeButton == 7
                      ? "btn btn-sm btn-secondary mt-1"
                      : "btn btn-sm btn-secondary mt-1"
                  }
                  onClick={() => {
                    handleChangeforChartofaccount(7);
                    setPreviewData(true);
                    setIncome(false);
                  }}
                >
                  <i className="fa fa-tags "></i> Equity
                </button>
              </div>
            </div>

            <Formik
              {...props}
              initialValues={formValues}
              validationSchema={validationSchema}
              onSubmit={handleSubmit}
              enableReinitialize
            >
              {({ values, errors, touched, handleChange, setFieldValue }) => (
                <Form>
                  <div className="card-body">
                    <div className="row">
                      <div className="col-md-6">
                        <div className="row">
                          <label className="col-md-4 col-form-label">
                            Save account under
                          </label>
                          <div className="col-md-8">
                            <TreeSelect
                              value={
                                SelectedAccountType
                                // Accounttype.find(
                                //     (option) =>
                                //         option.key
                                //         === SelectedAccountType.value
                                // ) || ""
                              }
                              onChange={(evnt) =>
                                handleChangeforaccountType(evnt)
                              }
                              options={tree}
                              filter
                              className="md:w-40rem w-full "
                              placeholder="Select Item"
                              isDisabled={hideAccounttype > 0 ? false : true}
                            ></TreeSelect>
                            {/* </div> */}
                            {/* value={selectedNodeKey} */}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="row mt-3">
                      <div className="col-md-6">
                        <div className="row">
                          <label className="col-form-label col-md-4">
                            Tax form section
                          </label>
                          <div className="col-md-8">
                            <Select
                              backspaceRemovesValue={false}
                              controlShouldRenderValue={true}
                              hideSelectedOptions={true}
                              // isMulti={true}

                              isClearable={true}
                              onChange={(evnt) => handleChangeforTaxForm(evnt)}
                              options={AccountDetailsTypeList}
                              placeholder=""
                              value={
                                AccountDetailsTypeList.find(
                                  (option) =>
                                    option.value ===
                                    SelectedAccountDetails.value
                                ) || ""
                              }
                              isDisabled={hideTaxformsection > 0 ? false : true}
                              id="AccountDetlailsType"
                              name="AccountDetlailsType"
                              className="custom-search-select "
                              styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="row mt-3">
                      <div className="col-md-6">
                        <div className="row">
                          <p className="col-form-label col-md-4 p-medium">
                            Account  Name<span className="text-danger">*</span>
                          </p>
                          <div className="col-md-8">
                            <Field
                              type="text"
                              className={`form-control form-control-sm ${
                                errors.Name ? "is-invalid" : ""
                              } ${hideDetails > 0 ? "" : "disabled"}`}
                              id="Name"
                              name="Name"
                              value={accountName}
                              onInput={(e) => handleInputChange(e)}
                              onChange={handleChange}
                              disabled={!hideDetails}
                            />
                            <div className="invalid-feedback">
                              {touched.Name && errors.Name ? errors.Name : ""}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="row mt-3">
                      <div className="col-md-6">
                        <div className="row">
                          <p className="col-form-label col-md-4 p-medium">
                            Description
                          </p>
                          <div className="col-md-8">
                            <Field
                              type="text"
                              className={`form-control ${
                                hideDetails > 0 ? "" : "disabled"
                              }`}
                              id="Description"
                              name="Description"
                              onChange={handleChange}
                              disabled={!hideDetails}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* {console.log(income,"income")} */}
                    {previewdata || activeButton >= 3 ? (
                      ""
                    ) : (
                      <>
                        <div className="row mt-3">
                          <div className="col-md-6">
                            <div className="form-group">
                              <strong>Profit & Loss</strong>
                              <label>
                                Balance as of{" "}
                                {Moment(currentdate).format("MM-DD-YYYY")}
                              </label>
                            </div>
                          </div>
                        </div>
                      </>
                    )}
                    {paramObject.id > 0 && activeButton >= 3 ? (
                      <>
                        <div className="row mt-3">
                          <div className="col-md-6">
                            <div className="form-group">
                              <strong>Balance</strong>
                              <label>{selectedaccounttypedata.Amount}</label>
                            </div>
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-md-6">
                            <div className="form-group">
                              <strong>Opening Balance</strong>
                              <label>
                                {parseFloat(
                                  selectedaccounttypedata?.OpeningBalance
                                ).toFixed(2)}
                              </label>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-md-6">
                            <div className="form-group">
                              <strong>Opening Date</strong>
                              <label>
                                {Moment(
                                  selectedaccounttypedata?.OpeningDate
                                ).format("YYYY-MM-DD")}
                              </label>
                            </div>
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-md-6">
                            <div className="form-group">
                              <strong>Balance Sheet</strong>
                              <label>
                                Balance as of{" "}
                                {Moment(currentdate).format("MM-DD-YYYY")}
                              </label>
                            </div>
                          </div>
                        </div>
                      </>
                    ) : previewdata || activeButton >= 3 ? (
                      <>
                        <div className="row mt-3">
                          <div className="col-md-6">
                            <div className="">
                              {
                                <>
                                  <div onClick={handlelistdata}>
                                    <p className="p-medium form-control-label">
                                      <strong>
                                        Starting date and opening balance
                                      </strong>
                                    </p>
                                  </div>

                                  <Select
                                    options={options}
                                    backspaceRemovesValue={false}
                                    controlShouldRenderValue={true}
                                    hideSelectedOptions={true}
                                    styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                                    className="custom-search-select w-50"
                                    // isMulti={true}
                                    isClearable={true}
                                    placeholder="Select date"
                                    onChange={(evnt) => handledata(evnt)}
                                    //  value={
                                    //     options.find(
                                    //         (option) =>
                                    //             option.value
                                    //     ) || ""
                                    // }
                                  />
                                  <p>
                                    Date to start tracking this account in Sonar Pos  
                                  </p>
                                  <p className="text-danger font-bold">*if you are using the quickbook then you need to add opening balance manualy in quickbook before you do any transaction.</p>
                                </>
                                // :
                                // <div onClick={handlelistdata}>
                                //   <FontAwesomeIcon icon={faChevronUp} /><strong style={{ marginLeft: "7px" }}>Starting date and opening balance</strong>
                                // </div>
                              }

                              {value == 2 ? (
                                <>
                                  <div className="col-md-8">
                                    <Field
                                      type="text"
                                      className={`form-control ${errors.Name ? "is-invalid" : ""
                                          } ${hideDetails > 0 ? "" : "disabled"}`}
                                      id="Amount"
                                      name="Amount"
                                      onChange={handleChange}
                                      // readOnly 
                                      // disabled={!hideDetails}
                                    />
                                    {/* <div className="invalid-feedback">
                                                            {touched.Name && errors.Name ? errors.Name : ""}
                                                          </div> */}
                                  </div>
                                  <label>
                                    Account Balance at end of day{" "}
                                    {Moment(
                                      lastDayPrevMonthForLastMonth
                                    ).format("YYYY-MM-DD")}
                                  </label>
                                </>
                              ) : (
                                ""
                              )}
                              {value == 1 ? (
                                <>
                                  <label>
                                    Account Balance at end of day {lastyear}
                                  </label>
                                  <div className="col-md-8">
                                    <Field
                                      type="text"
                                      className={`form-control ${errors.Name ? "is-invalid" : ""
                                          } ${hideDetails > 0 ? "" : "disabled"}`}
                                      id="Amount"
                                      name="Amount"
                                      onChange={handleChange}
                                      // readOnly 
                                      // disabled={!hideDetails}
                                    />
                                    {/* <div className="invalid-feedback">
                                                            {touched.Name && errors.Name ? errors.Name : ""}
                                                        </div> */}
                                  </div>
                                </>
                              ) : (
                                ""
                              )}
                              {value == 3 ? (
                                <>
                                  <div className="col-md-8">
                                    <Field
                                      type="text"
                                      className={`form-control ${errors.Name ? "is-invalid" : ""
                                          } ${hideDetails > 0 ? "" : "disabled"}`}
                                      id="Amount"
                                      name="Amount"
                                      onChange={handleChange}
                                      // readOnly 
                                      // disabled={!hideDetails}
                                    />
                                    {/* <div className="invalid-feedback">
                                                            {touched.Name && errors.Name ? errors.Name : ""}
                                                          </div> */}
                                  </div>
                                  <label>
                                    Account Balance at end of day{" "}
                                    {Moment(currentdate).format("YYYY-MM-DD")}
                                  </label>
                                </>
                              ) : (
                                ""
                              )}
                              {value == 4 ? (
                                <>
                                  <label>Start date</label>
                                  <div>
                                    <input
                                      type="date"
                                      className="form-control form-control-sm"
                                      id="StartDate"
                                      name="StartDate"
                                      onChange={(e) => handledateChange(e)}
                                      // readOnly 
                                      //  onChange={(event) =>
                                      //  handleChangeCustomStartingDate(event)
                                      //  }
                                    />
                                  </div>

                                  {date ? (
                                    <>
                                      <label>
                                        Account balance at end of day{" "}
                                        {datevalue}
                                      </label>
                                      <div className="col-md-8">
                                        <Field
                                          type="text"
                                          className={`form-control ${errors.Name ? "is-invalid" : ""
                                              } ${hideDetails > 0 ? "" : "disabled"}`}
                                          id="Amount"
                                          name="Amount"
                                          onChange={handleChange}
                                          // readOnly 
                                          // disabled={!hideDetails}
                                        />
                                        {/* <div className="invalid-feedback">
                                                            {touched.Name && errors.Name ? errors.Name : ""}
                                                        </div> */}
                                      </div>
                                    </>
                                  ) : (
                                    ""
                                  )}
                                </>
                              ) : (
                                ""
                              )}
                            </div>
                          </div>
                        </div>

                        <div className="row mt-3">
                          <div className="col-md-6">
                            <div className="form-group col">
                              <strong>Balance Sheet</strong>
                              <label>
                                Balance as of{" "}
                                {Moment(currentdate).format("MM-DD-YYYY")}
                              </label>
                            </div>
                          </div>
                        </div>
                      </>
                    ) : (
                      ""
                    )}
                    <div
                      style={{
                        display: "flex",
                        gap: "1rem",
                        justifyContent: "flex-end",
                      }}
                    >
                      <button
                        type="submit"
                        className="btn btn-sm btn-secondary mt-3 mb-3"
                        onClick={() => {
                          setFieldValue("buttonType", "saveAndClose");
                        }}
                      >
                        Save & Close
                      </button>
                      <button
                        type="submit"
                        className="btn btn-sm btn-primary mt-3 mb-3"
                        onClick={() => {
                          setFieldValue("buttonType", "saveAndNew");
                        }}
                      >
                        Save & New
                      </button>
                    </div>
                    <div className="card card-border">
                      <p class="p-medium m-3" style={{ color: "#000" }}>
                        List of Account Details
                      </p>
                      <hr className="hr"></hr>
                      <div
                        className="row mt-2 mb-3"
                        style={{ marginLeft: "6px" }}
                      >
                        <div className="col-md-12">
                          {/* {console.log(Accounttype,"accounttype")} */}
                          {previewdisplay?.map((item, index) =>
                            item.children ? (
                              <ParentChildRecursive
                                data={item}
                                accountName={accountName}
                              />
                            ) : (
                              <p
                                className={
                                  item.key == -2
                                    ? "text-dark custom-preview"
                                    : ""
                                }
                              >
                                {item.label}
                              </p>
                            )
                          )}
                          {/* <ParentChildRecursive data={"sone"} /> */}
                        </div>
                      </div>
                    </div>

                    {/* <div className="pull-right mb-3">
                                            <button
                                                type="submit"
                                                className="btn btn-primary me-3"
                                            >
                                                Save
                                            </button>
                                            <Link
                                                to="/accounting"
                                                className="btn btn-secondary"
                                            >
                                                Cancel
                                            </Link>
                                        </div> */}
                    {/* <div
                      style={{
                        display: "flex",
                        gap: "1rem",
                        justifyContent: "flex-end",
                      }}
                    >
                      <button
                        type="submit"
                        className="btn btn-sm btn-secondary mt-3 mb-3"
                        onClick={() => {
                          setFieldValue("buttonType", "saveAndClose");
                        }}
                      >
                        Save & Close
                      </button>
                      <button
                        type="submit"
                        className="btn btn-sm btn-primary mt-3 mb-3"
                        onClick={() => {
                          setFieldValue("buttonType", "saveAndNew");
                        }}
                      >
                        Save & New
                      </button>
                    </div> */}
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </div>
      </div>
      {/* <Loader loading={loading} /> */}
    </>
  );
};

export default AccountTypeManage;

const ParentChildRecursive = ({ data, accountName }) => {
  console.log(accountName, "accountName");
  console.log(data, "data345");
  const option = data.children?.find(
    (item, index) => item.label == accountName
  );
  console.log(option, "option");

  // console.log(data, "hhhhhhhhhhhhhhhhhh 1132")
  // console.log(paramObject?.id,"paramObject")
  // console.log("")
  if (!data) return null; // If data is not available yet, don't render anything

  return (
    <>
      <ul>
        <p className={data.key == -2 ? "text-dark custom-preview" : ""}>
          {data.label}
          {data.children && data.children.length > 0 && (
            <ul style={{ marginTop: "10px" }}>
              {data.children.map((child) => (
                <li
                  key={child.key}
                  style={{ marginLeft: "20px", marginTop: "10px" }}
                >
                  <ParentChildRecursive data={child} />
                </li>
              ))}
            </ul>
          )}
        </p>
      </ul>
    </>
  );
};
